import {
  CONNECTED_WIDGET_MESSAGE,
  USER_ACCESS_TOKEN_WIDGET_MESSAGE,
  CULTURE_WIDGET_MESSAGE,
  type Culture,
  type WidgetMessageAction,
} from './widgetMessages';
import { communicationStorage } from 'utils/storages';

export const INITIAL_REDUCER_STATE: ReducerState = {
  isConnected: false,
  userAccessToken: null,
  culture: null,
};

export type ReducerState = {
  isConnected: boolean;
  userAccessToken: string | null;
  culture: Culture | null;
};

export function reducer(state: ReducerState, action: WidgetMessageAction): ReducerState {
  switch (action.type) {
    case CONNECTED_WIDGET_MESSAGE:
      return { ...state, isConnected: true };
    case USER_ACCESS_TOKEN_WIDGET_MESSAGE:
      communicationStorage.setUserAccessToken(action.payload.userAccessToken);
      return { ...state, userAccessToken: action.payload.userAccessToken };
    case CULTURE_WIDGET_MESSAGE:
      communicationStorage.setCultureName(action.payload.culture.name);
      return { ...state, culture: action.payload.culture };
    default:
      return state;
  }
}
